import { render, staticRenderFns } from "./SucCheckboxFieldComponent.vue?vue&type=template&id=5c72a5cc&"
import script from "./SucCheckboxFieldComponent.vue?vue&type=script&lang=js&"
export * from "./SucCheckboxFieldComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c72a5cc')) {
      api.createRecord('5c72a5cc', component.options)
    } else {
      api.reload('5c72a5cc', component.options)
    }
    module.hot.accept("./SucCheckboxFieldComponent.vue?vue&type=template&id=5c72a5cc&", function () {
      api.rerender('5c72a5cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form/SucCheckboxFieldComponent.vue"
export default component.exports